import React from 'react';
import './circle.scss';

interface ICircleProps {
  width?: number;
  height?: number;
  borderColor?: string;
}

const Circle: React.FC<ICircleProps> = ({
  borderColor = '#0099cc',
  height = 40,
  width = 40,
}) => {
  return (
    <div className="lds-ring">
      <div
        style={{
          width,
          height,
          borderColor: `${borderColor} transparent transparent transparent`,
        }}
      ></div>
      <div
        style={{
          width,
          height,
          borderColor: `${borderColor} transparent transparent transparent`,
        }}
      ></div>
      <div
        style={{
          width,
          height,
          borderColor: `${borderColor} transparent transparent transparent`,
        }}
      ></div>
      <div
        style={{
          width,
          height,
          borderColor: `${borderColor} transparent transparent transparent`,
        }}
      ></div>
    </div>
  );
};

export default Circle;
